/** Narrow protocol shared by our /call page and its native call container. */
export const CALL_AUDIO_EVENT = 'dislix:call-audio';
export const CALL_COMMAND_EVENT = 'dislix:call-command';
export const ACTIVE_CALL_STATES = new Set(['calling', 'ringing', 'connected']);
export const TERMINAL_CALL_STATES = new Set(['completed', 'ended', 'cancelled', 'not-responded', 'failed']);
export function parseCallBridgeMessage(raw: string):
  | { type: 'dismissCallScreen' | 'getCallAudioState' }
  | { type: 'setCallSpeaker'; enabled: boolean }
  | { type: 'callState'; state: string }
  | null {
  try {
    const m = JSON.parse(raw);
    if (m?.type === 'dismissCallScreen' || m?.type === 'getCallAudioState') return { type: m.type };
    if (m?.type === 'setCallSpeaker' && typeof m.enabled === 'boolean') return { type: m.type, enabled: m.enabled };
    if (m?.type === 'callState' && (ACTIVE_CALL_STATES.has(m.state) || TERMINAL_CALL_STATES.has(m.state))) return { type: m.type, state: m.state };
  } catch { /* Untrusted/malformed bridge messages have no side effects. */ }
  return null;
}
export function callPageEventScript(name: typeof CALL_AUDIO_EVENT | typeof CALL_COMMAND_EVENT, detail: object): string {
  // This is a JS expression, not HTML. JSON.stringify safely carries event data.
  return `window.dispatchEvent(new CustomEvent(${JSON.stringify(name)}, { detail: ${JSON.stringify(detail)} })); true;`;
}
